import http from '@/services/rest/rest.service';
import { INewsModel } from '@/entities';

export default {
    lastNews(): Promise<INewsModel> {
        return http.get('news/last');
    },
    update(model: INewsModel): Promise<number> {
        return http.post('news', model);
    }
};
